<div id="confirmDialog" 
    appDraggable dragTarget="#confirmDialog" dragHandle="#confirmDialogHeader"
    class="modal fade in ui-draggable ui-draggable-handle locationAlertDataPane"
    style="width:auto; min-width: 450px; max-width: 100%; min-height: 200px; height: auto; overflow-y: auto; max-height: 100%; display: none;"
    role="dialog"
    tabindex="-1"
    >

    <div role="document" id="confirmDialogContent">
        <div class="modal-content modal-dialog">

            <div class="modal-header" id="confirmDialogHeader">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCancelClicked()">
                    <span aria-hidden="true">x</span>
                </button>
                <h4 class="modal-title">
                    <span>{{ title }}</span>
                </h4>
            </div>

			<div class="modal-body">
				<p> {{ message }} </p>
			</div>

            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="onCancelClicked()">
                    <i class="fa fa-ban"></i> NO
                </button>
                <button type="button" class="btn btn-primary" (click)="onConfirmClicked()">
                    <i class="fa fa-refresh"></i> YES
                </button>
            </div>

        </div>
    </div>

</div>